import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtokumtacab() {



    const cardData = {




keyword: "Belgaum to Kumta Cab",

headingDescription: "Belgaum Taxi Service provides comfortable, safe, and reliable Belgaum to Kumta cab services for beach trips, family vacations, pilgrimage journeys, business travel, and outstation transportation. We offer one-way taxi, round-trip cab, and customized travel options from Belgaum to Kumta with professional drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. With doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support, we ensure a smooth and convenient journey between Belgaum and Kumta. Whether you are planning a coastal holiday, visiting temples, exploring beaches, or traveling for personal and business requirements, Belgaum Taxi Service provides dependable cab solutions with experienced chauffeurs, clean vehicles, and comfortable travel facilities.",

topPlaces: [
  {
    title: "Kumta",
    description: "Kumta is a beautiful coastal town in Karnataka known for its pristine beaches, temples, traditional culture, and peaceful surroundings. It is an ideal destination for travelers looking to explore the natural beauty of the Konkan coastline. The town also acts as a gateway to several nearby beaches, villages, and tourist attractions."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a famous coastal and pilgrimage destination near Kumta, known for Mahabaleshwar Temple, Om Beach, Kudle Beach, and scenic coastal landscapes. It attracts pilgrims, beach lovers, couples, and adventure travelers throughout the year."
  },
  {
    title: "Om Beach",
    description: "Om Beach is one of the most popular attractions near Kumta and Gokarna, famous for its unique shoreline shape, Arabian Sea views, beach activities, cafes, and beautiful sunset experiences. It is a perfect place for relaxation and photography."
  },
  {
    title: "Mirjan Fort",
    description: "Mirjan Fort is a historic fort near Kumta known for its impressive architecture, laterite stone walls, greenery, and historical importance. It is a popular sightseeing destination for history enthusiasts and tourists exploring coastal Karnataka."
  },
  {
    title: "Yana Caves",
    description: "Yana Caves is a unique natural attraction near Kumta famous for massive black limestone rock formations, dense forests, trekking routes, and peaceful surroundings. It is a preferred destination for nature lovers and adventure travelers."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a famous coastal pilgrimage destination known for the giant Shiva statue, Murudeshwar Temple, beautiful beaches, and Arabian Sea views. Many travelers include Murudeshwar while exploring the coastal Karnataka route."
  },
  {
    title: "Karwar",
    description: "Karwar is a scenic coastal city known for beaches, islands, naval facilities, and natural beauty. It is a popular destination for travelers looking for peaceful beach experiences and coastal sightseeing."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a popular adventure destination in Karnataka known for wildlife sanctuary, river rafting, jungle safari, forests, and outdoor activities. It is an excellent addition for travelers planning a longer Karnataka tour."
  },
  {
    title: "Goa",
    description: "Goa is a world-famous holiday destination known for beautiful beaches, resorts, churches, nightlife, water sports, and coastal attractions. Travelers often combine Kumta, Gokarna, and Goa for an extended beach tour."
  },
  {
    title: "Jog Falls",
    description: "Jog Falls is one of India's highest waterfalls and a major natural attraction in Karnataka. Surrounded by greenery and scenic landscapes, it is a popular destination for families, photographers, and nature lovers."
  }
],




"services": [
  {
    "name": "Belgaum to Kumta Cab",
    "description": "Book Belgaum to Kumta Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for family trips, business travel, sightseeing, and convenient journeys between Belgaum and Kumta."
  },
  {
    "name": "Belgaum to Kumta Taxi",
    "description": "Choose Belgaum to Kumta Taxi for comfortable intercity transportation with experienced drivers, clean vehicles, and affordable travel solutions. Enjoy a smooth journey with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Kumta Cab Service",
    "description": "Book Belgaum to Kumta Cab Service for reliable travel with doorstep pickup, professional chauffeurs, and comfortable vehicles. Our cab services are suitable for family trips, business journeys, sightseeing, and long-distance transportation."
  },
  {
    "name": "Belgaum to Kumta Taxi Service",
    "description": "Get Belgaum to Kumta Taxi Service with affordable fares, trained drivers, and multiple vehicle choices. Travel conveniently with safe and comfortable taxi services designed for personal and corporate travel needs."
  },
  {
    "name": "Belgaum to Kumta One Way Cab",
    "description": "Book Belgaum to Kumta One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, clean AC vehicles, and reliable chauffeur services."
  },
  {
    "name": "Belgaum to Kumta One Way Taxi",
    "description": "Choose Belgaum to Kumta One Way Taxi for affordable and convenient one-direction travel. Get professional drivers, flexible pickup options, and comfortable vehicles for a hassle-free journey."
  },
  {
    "name": "Belgaum to Kumta Cab Booking",
    "description": "Complete Belgaum to Kumta Cab Booking online with easy reservations, quick confirmation, and multiple vehicle options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel requirements."
  },
  {
    "name": "Belgaum to Kumta Taxi Booking",
    "description": "Reserve Belgaum to Kumta Taxi Booking services for reliable transportation with experienced chauffeurs. Get affordable taxi options with flexible schedules for family trips, business travel, and personal journeys."
  },
  {
    "name": "Belgaum to Kumta Car Rental",
    "description": "Choose Belgaum to Kumta Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for sightseeing, family vacations, corporate travel, and outstation transportation."
  },
  {
    "name": "Belgaum to Kumta Outstation Cab",
    "description": "Hire Belgaum to Kumta Outstation Cab for safe and comfortable long-distance travel. Enjoy clean AC vehicles, experienced drivers, transparent pricing, and flexible one way or round trip packages."
  },
  {
    "name": "Belgaum to Kumta Innova Crysta Cab",
    "description": "Book Belgaum to Kumta Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and professional chauffeurs. Perfect for family groups, corporate journeys, and comfortable trips."
  },
  {
    "name": "Belgaum to Kumta Ertiga Cab",
    "description": "Choose Belgaum to Kumta Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, group travel, and long-distance journeys."
  },
  {
    "name": "Belgaum to Kumta Sedan Cab",
    "description": "Book Belgaum to Kumta Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for couples, business trips, and smooth highway travel."
  },
  {
    "name": "Belgaum to Kumta Round Trip Cab",
    "description": "Hire Belgaum to Kumta Round Trip Cab for convenient return journeys with affordable packages and flexible schedules. Perfect for sightseeing, family visits, beach trips, and weekend getaways."
  },
  {
    "name": "Belgaum to Kumta Private Taxi",
    "description": "Reserve Belgaum to Kumta Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Kumta Cab",
    "description": "Find Cheap Belgaum to Kumta Cab services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably with budget-friendly transportation without compromising safety and convenience."
  },
  {
    "name": "Best Belgaum to Kumta Cab Service",
    "description": "Choose the Best Belgaum to Kumta Cab Service with premium vehicles, trained drivers, competitive pricing, and dependable support. Experience smooth and comfortable travel for all journey requirements."
  },
  {
    "name": "Online Belgaum to Kumta Cab Booking",
    "description": "Complete Online Belgaum to Kumta Cab Booking with simple reservations, instant confirmation, and flexible travel options. Get doorstep pickup and comfortable vehicles for a convenient journey."
  },
  {
    "name": "Belgaum to Kumta Taxi Fare",
    "description": "Check Belgaum to Kumta Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
  },
  {
    "name": "Belgaum to Kumta Car Hire",
    "description": "Hire Belgaum to Kumta Car Hire services for private transportation with chauffeur-driven vehicles. Choose from multiple car categories suitable for family, corporate, and personal travel."
  },
  {
    "name": "Belgaum to Kumta Cab Price",
    "description": "Get affordable Belgaum to Kumta Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
  },
  {
    "name": "Belgaum to Kumta Family Cab",
    "description": "Book Belgaum to Kumta Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for vacations, sightseeing, temple visits, and personal journeys."
  },
  {
    "name": "Belgaum to Kumta Corporate Taxi",
    "description": "Choose Belgaum to Kumta Corporate Taxi services for business travel, employee transportation, and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Kumta Airport Transfer",
    "description": "Book Belgaum to Kumta Airport Transfer services for timely pickup and drop with comfortable vehicles and experienced chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
  },
  {
    "name": "Belgaum to Kumta Cab Fare",
    "description": "Get the best Belgaum to Kumta Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
  },
  {
    "name": "Belgaum to Kumta Taxi Near Me",
    "description": "Find Belgaum to Kumta Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
  },
  {
    "name": "Belgaum to Kumta Outstation Taxi",
    "description": "Book Belgaum to Kumta Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, experienced chauffeurs, and flexible travel plans for personal and business journeys."
  },
  {
    "name": "Belgaum to Kumta Travel by Cab",
    "description": "Experience comfortable Belgaum to Kumta Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with convenient pickup and customized travel solutions."
  }
],
"tableData": [
  ["Belgaum to Kumta Cab", "Belgaum to Kumta Taxi"],
  ["Belgaum to Kumta Cab Service", "Belgaum to Kumta Taxi Service"],
  ["Belgaum to Kumta One Way Cab", "Belgaum to Kumta One Way Taxi"],
  ["Belgaum to Kumta Cab Booking", "Belgaum to Kumta Taxi Booking"],
  ["Belgaum to Kumta Car Rental", "Belgaum to Kumta Outstation Cab"],
  ["Belgaum to Kumta Innova Crysta Cab", "Belgaum to Kumta Ertiga Cab"],
  ["Belgaum to Kumta Sedan Cab", "Belgaum to Kumta Round Trip Cab"],
  ["Belgaum to Kumta Private Taxi", "Cheap Belgaum to Kumta Cab"],
  ["Best Belgaum to Kumta Cab Service", "Online Belgaum to Kumta Cab Booking"],
  ["Belgaum to Kumta Taxi Fare", "Belgaum to Kumta Car Hire"],
  ["Belgaum to Kumta Cab Price", "Belgaum to Kumta Family Cab"],
  ["Belgaum to Kumta Corporate Taxi", "Belgaum to Kumta Airport Transfer"],
  ["Belgaum to Kumta Cab Fare", "Belgaum to Kumta Taxi Near Me"],
  ["Belgaum to Kumta Outstation Taxi", "Belgaum to Kumta Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Kumta Cab Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Kumta with a dependable taxi service offering well-maintained vehicles, experienced drivers, and convenient travel options for coastal and personal journeys."
  },
  {
    WhyChooseheading: "Smooth Intercity Travel Experience",
    WhyChoosedescription: "Enjoy direct transportation between Belgaum and Kumta with doorstep pickup and drop facilities that make your journey simple and comfortable."
  },
  {
    WhyChooseheading: "Cab Options for Every Traveller",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on your passenger count, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "Perfect for Family & Holiday Trips",
    WhyChoosedescription: "Our Belgaum to Kumta taxis are suitable for family vacations, beach visits, temple trips, business travel, and personal transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Coastal Routes",
    WhyChoosedescription: "Professional chauffeurs provide safe driving, timely service, and comfortable travel with proper knowledge of the Belgaum to Kumta route."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Select a one-way taxi for direct travel or plan a return journey according to your preferred schedule and travel requirements."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Long Journeys",
    WhyChoosedescription: "Travel in clean and well-maintained cars with spacious seating to enjoy a relaxed journey from Belgaum to Kumta."
  },
  {
    WhyChooseheading: "Easy Cab Booking Support",
    WhyChoosedescription: "Get quick assistance for vehicle selection, fare details, and taxi availability to arrange your Belgaum to Kumta cab easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Kumta Cab Service?",
    answer: "Yes, we provide Belgaum to Kumta cab services with comfortable vehicles and professional drivers for outstation travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Kumta?",
    answer: "Yes, one-way cab services are available for passengers who need direct travel between Belgaum and Kumta."
  },
  {
    question: "Which vehicles are available for Belgaum to Kumta travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    question: "Is Belgaum to Kumta cab suitable for family trips?",
    answer: "Yes, comfortable and spacious vehicles are available for families and groups travelling to Kumta."
  },
  {
    question: "Can I book a return cab from Kumta to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings based on your travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Kumta?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Kumta taxi service available anytime?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Kumta Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Kulkarni",
    feedback: "The Belgaum to Kumta cab service was very comfortable. The driver was professional, and the journey was smooth from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Naik",
    feedback: "We travelled with family to Kumta and had a great experience. The cab was clean, spacious, and the service was reliable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Kumta Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-kumta-cab.webp",
  "description":
    "Book Belgaum to Kumta Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Kumta with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for beach trips, family vacations, business travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-kumta-cab"
  }
};






    return (
        <div>


<Helmet>
  <title>Belgaum to Kumta Cab | Online Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Kumta Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable and comfortable outstation travel from Belgaum to Kumta with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Kumta Cab, Belgaum to Kumta Taxi, Belgaum to Kumta Cab Service, Belgaum to Kumta Taxi Service, Belgaum to Kumta One Way Cab, Belgaum to Kumta One Way Taxi, Belgaum to Kumta Cab Booking, Belgaum to Kumta Taxi Booking, Belgaum to Kumta Car Rental, Belgaum to Kumta Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtokumtacab ;